import React, { useEffect, useState } from 'react';
import { evidenceStamp } from '../lib/fieldOperation';
import { evaluationsAPI } from '../api/client';
import { evidencePins, mountEvidencePins } from '../lib/evidenceMap';

export default function EvidenceLayer({ evaluationId, map, emptyMessage }) {
  const [points, setPoints] = useState([]);
  const [zones, setZones] = useState([]);
  const [visible, setVisible] = useState(true);
  const [status, setStatus] = useState('Cargando');
  useEffect(() => {
    let current = true;
    setPoints([]);
    setZones([]);
    if (!evaluationId) return;
    setStatus('Cargando');
    evaluationsAPI.getGeo(evaluationId).then(({ data }) => {
      if (current) {
        setPoints(evidencePins(data.points || []));
        setZones(data.zone_only || []);
        setStatus('');
      }
    }).catch(() => {
      if (current) setStatus('No se pudieron cargar las evidencias');
    });
    return () => {
      current = false;
    };
  }, [evaluationId]);
  useEffect(() => {
    if (!map || !visible) return;
    return mountEvidencePins(map, points);
  }, [map, points, visible]);
  return (
    <div className="flex flex-wrap items-center gap-2 bg-white text-slate-700 p-2 text-sm">
      <label className="flex items-center gap-2">
        <input type="checkbox" checked={visible} onChange={(event) => setVisible(event.target.checked)} />
        Evidencias ({points.length})
      </label>
      {status && <span role="status">{status}</span>}
      {!status && points.length === 0 && zones.length === 0 && emptyMessage && <p role="status">{emptyMessage}</p>}
      {!!zones.length && <section className="w-full"><h3>Ubicaciones registradas solo por zona</h3>
        <ul>{zones.map((entry, i) => <li key={i}>
          <strong>{entry.code} {entry.title}</strong> · {entry.answer_label || entry.answer || entry.response || 'Sin respuesta'}
          <p>{evidenceStamp(entry)}</p>{entry.below_standard && <p>Por debajo del estándar</p>}
        </li>)}</ul>
      </section>}
      {map && points.length > 0 && (
        <button type="button" onClick={() => map.panTo({ lat: points[0].lat, lng: points[0].lng })}>
          Ver ubicación
        </button>
      )}
    </div>
  );
}
